import React from 'react';
import { Button, Col, Dropdown, Row } from 'antd';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Tooltip } from 'components';
import { FilterBar2ListItem } from '../types';

interface FilterMoreProps {
	children: string;
	list: FilterBar2ListItem[];
	onAdd: Function;
	visible: boolean;
	onVisibleChange: (visible: boolean) => void;
	disabled: boolean;
}

export const FilterMore = ({ children, list, visible, onAdd, onVisibleChange, disabled }: FilterMoreProps) => (
	<Dropdown
		arrow
		trigger={['click']}
		disabled={disabled}
		open={visible}
		onOpenChange={onVisibleChange}
		placement="bottom"
		overlayClassName="more-filters-dropdown"
		menu={{
			className: 'filter-bar-2-more-menu',
			onClick: e => {
				onAdd(list.find(({ name }) => e.key === name));
			},
			items: list.map(item => ({
				key: item.name,
				'data-test-id': `additional-filter-${item.name}`,
				label: (
					<Row align="middle">
						<Col flex="auto">{item.title}</Col>
						<Col>
							{item.tooltip ? (
								<Tooltip className="filter-bar-2-tooltip" title={item.tooltip}>
									<BringgIcon
										iconName={BringgFontIcons.CircleExclamation}
										className="more-info-icon"
									/>
								</Tooltip>
							) : null}
						</Col>
					</Row>
				)
			}))
		}}
	>
		<Button className="filter-bar-2-more-button" type="link">
			{children}
		</Button>
	</Dropdown>
);
